import axios from 'axios';

// 创建一个 axios 实例
const service = axios.create({
    baseURL: 'https://cz.yemtech.com.cn/prod-api', // 根据环境变量设置请求的基础 URL
    timeout: 5000 // 请求超时时间
});

// 请求拦截器
service.interceptors.request.use(
    config => {
        // 在发送请求之前做些什么，例如添加 token
        const token = localStorage.getItem('token');
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    error => {
        // 处理请求错误
        console.log(error);
        return Promise.reject(error);
    }
);

// 响应拦截器
service.interceptors.response.use(
    response => {
        const res = response.data;
        // 如果响应码不是 200，则认为请求失败
        if (res.code != 200) {
            console.log(res.message || 'Error');
            return;
        } else {
            return res;
        }
    },
    error => {
        console.log('err' + error);
        return Promise.reject(error);
    }
);

export default service;